import { html } from "lit";
import { store } from "../../../platform/store/DataStore.js";

export class TeacherTableService {
  static getColumns() {
    return [
      { key: "name", label: "Namn", width: "200px" },
      { key: "compatible_courses", label: "Kompatibla kurser", width: "250px" },
      { key: "examinator_courses", label: "Examinator för", width: "250px" },
      { key: "actions", label: "Åtgärder", width: "160px" },
    ];
  }

  static renderCell(
    teacher,
    column,
    onEdit,
    onDelete,
    onInfo,
    isSaving = false
  ) {
    if (!teacher || !column) return html``;

    switch (column.key) {
      case "name":
        return html`
          <button
            class="teacher-name-button"
            type="button"
            @click="${() => onInfo?.(teacher.teacher_id)}"
          >
            ${teacher.name}
          </button>
        `;
      case "compatible_courses":
        const compatibleCourses = store
          .getCourses()
          .filter((c) => teacher.compatible_courses?.includes(c.course_id))
          .map((c) => c.code)
          .join(", ");
        return html`${compatibleCourses || "-"}`;
      case "examinator_courses":
        const examinatorCourses = store
          .getExaminatorCoursesForTeacher(teacher.teacher_id)
          .map((c) => c.code)
          .join(", ");
        return html`${examinatorCourses || "-"}`;
      case "actions":
        return html`
          <div style="display: flex; gap: var(--space-2);">
            <henry-button
              variant="secondary"
              size="small"
              ?disabled=${!store.editMode || isSaving}
              @click="${() => onEdit?.(teacher.teacher_id)}"
            >
              Redigera
            </henry-button>
            <henry-button
              variant="danger"
              size="small"
              ?disabled=${!store.editMode || isSaving}
              @click="${() => onDelete?.(teacher.teacher_id)}"
            >
              Ta bort
            </henry-button>
          </div>
        `;
      default:
        return html`${teacher[column.key] ?? ""}`;
    }
  }
}
